import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { selectRecentEventForReview } from "../../Tagging/store/slices/socket/selectors";

export const useChallengeCountdown = () => {
  const recentEvent = useSelector(selectRecentEventForReview);
  const [isCountingDown, setIsCountingDown] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(5);

  const previousEventUUIDRef = useRef<string | undefined>(undefined);
  const countdownIntervalRef = useRef<ReturnType<typeof setInterval> | null>(
    null,
  );

  useEffect(() => {
    const currentEventUUID = recentEvent?.event_uuid;

    // New pitch detected (using event_uuid since pitchUUID is undefined)
    if (currentEventUUID && currentEventUUID !== previousEventUUIDRef.current) {
      previousEventUUIDRef.current = currentEventUUID;
      setIsCountingDown(true);
      setSecondsLeft(5);

      // Clear existing interval if any
      if (countdownIntervalRef.current) {
        clearInterval(countdownIntervalRef.current);
      }

      // Start countdown
      countdownIntervalRef.current = setInterval(() => {
        setSecondsLeft((prev) => {
          const newValue = prev - 1;
          if (prev <= 1) {
            setIsCountingDown(false);
            if (countdownIntervalRef.current) {
              clearInterval(countdownIntervalRef.current);
              countdownIntervalRef.current = null;
            }
            return 0;
          }
          return newValue;
        });
      }, 1000);
    }

    return () => {
      if (countdownIntervalRef.current) {
        clearInterval(countdownIntervalRef.current);
      }
    };
  }, [recentEvent?.event_uuid]);

  return { isCountingDown, secondsLeft };
};
